import { Component, OnInit, ViewChild } from '@angular/core';
import { ApkWebhookComponent } from './components/apk-webhook/apk-webhook.component';
import { OutbondWebhookComponent } from './components/outbond-webhook/outbond-webhook.component';
import { DeliveryWebhookComponent } from './components/delivery-webhook/delivery-webhook.component';

@Component({
  standalone: false,
  selector: 'app-webhook-qrisly',
  templateUrl: './webhook-qrisly.component.html',
  styleUrl: './webhook-qrisly.component.scss'
})
export class WebhookQrislyComponent implements OnInit {
  @ViewChild('apkWebhook') apkWebhook!: ApkWebhookComponent;
  @ViewChild('outbondWebhook') outbondWebhook!: OutbondWebhookComponent;
  @ViewChild('deliveryWebhook') deliveryWebhook!: DeliveryWebhookComponent;

  loading: boolean = true;
  selectedIndex: number = 0;

  ngOnInit(): void {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  onSelectedIndexChange(index: number): void {
    this.selectedIndex = index;
    if (this.selectedIndex === 0) {
      this.apkWebhook?.getSecretKey();
    } else if (this.selectedIndex === 1) {
      this.outbondWebhook?.getWebhook();
    } else if (this.selectedIndex === 2) {
      this.deliveryWebhook?.getDeliveryHistory();
    }
  }
}
